import React, { useRef, useState, useEffect } from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import Dashboard from '../../views/AdminView/Dashboard';
import PartnerDashboard from '../../views/PartnerView/PartnerDashboard';



const PartnerDashboardCompoent = () => {
 const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 
    const data = useRef('');
    const error = useRef('');
   
    
    const getData = async () => {
     
        try {
           
                setLoading(false); // Set loading to false once data is fetched
  
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });
    
    
    return <div>
  
    {!loading && <PartnerDashboard/> }
    </div>

   
};

export default PartnerDashboardCompoent;
